// extracted by mini-css-extract-plugin
module.exports = {"bottomContainer":"StickyFooterContent_bottomContainer__UP16Q"};